import { Children, forwardRef } from 'react';
import cn from 'classnames';
import { Button } from 'seagull';
import styles from "./ServicesListStructure.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ServicesListStructure = /*#__PURE__*/forwardRef(function ServicesListStructure(props, ref) {
  const {
    children,
    addServicesTestid,
    emptyState,
    centerVertically,
    isReadOnly,
    onAddService
  } = props;
  return /*#__PURE__*/_jsxs("section", {
    className: cn(styles.root, {
      [styles.centerVertically]: centerVertically
    }),
    ref: ref,
    children: [children, Children.count(children) === 0 && emptyState ? emptyState : !isReadOnly && /*#__PURE__*/_jsx(Button, {
      type: "button",
      className: styles.addServiceBtn,
      onClick: onAddService,
      "data-testid": addServicesTestid,
      children: "Add services"
    })]
  });
});
export default ServicesListStructure;